import { FaInstagram, FaPinterest, FaGithub, FaLinkedin } from "react-icons/fa";
import BtnHome from "../components/BtnHome";
import Tutorial from "../components/Tutorial";
import { IconChevronCompactUp } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function Home({ setTitle }) {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/Pokedex");
  };
  const ObjetoTutorial = [
    {
      title: "  Try your knowledge and discover the Pokémon!",
      description:
        " Uncover a new Pokémon using the Pokémon Random Tool — just click the button and guess who that Pokémon is!",
      url: "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2Fpokeball.png?alt=media&token=b28ebe6b-5bb2-4c7d-ac08-65223417329d",
      orientation: false,
    },
    {
      title: "  All the pokémon in one place!!",
      description: " Let's dive in and discover all 1,025 available Pokémon",
      url: "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2Fgiggly.png?alt=media&token=d7b26f0f-b02c-4892-bbf5-c230ac47239f",
      orientation: true,
    },
    {
      title: "Stats, evolutions and many more details",
      description:
        " Every creature is unique with characteristics that that stand out",
      url: "https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2Fdetailed-card.png?alt=media&token=6bdbfb5c-602f-4998-9ab0-164fcbf8dc3e",
      orientation: false,
    },
  ];
  const handleScroll = () => {
    window.scrollBy({ top: 400, behavior: "smooth" });
  };
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observerSlide = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.51 }
    );
    if (ref.current) {
      observerSlide.observe(ref.current);
    }
    return () => {
      if (ref.current) observerSlide.unobserve(ref.current);
    };
  }, []);
  return (
    <>
      <section className="hero-home">
        <div className="hero-content-ho">
          <div className="pachi-and-text">
            <div className="hero-title">
              <h1>Welcome to your digital Pokédex!</h1>
              <p>Explore the Pokémon world like never before.</p>
            </div>
            <div className="hero-pachirisu">
              <img
                title="hero img"
                alt="pachirisu"
                src="https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2Fpachirisu-hero.png?alt=media&token=cab5c202-eda8-4b40-8962-c407df007b8e"
                className="hero-img-pach"
              />
            </div>
          </div>

          <div className="hero-actions-ho">
            <BtnHome
              onClick={handleScroll}
              fontSizeHo="16px"
              colorBack="#3b82f6"
              message={"Start exploring"}
            />
            <BtnHome
              onClick={handleNavigate}
              fontSizeHo="16px"
              colorBack="red"
              message={"Discover a pokémon"}
            />
          </div>
          <div className="features-container">
            <div>
              <h2 className="feature-h2"> Features</h2>
            </div>
            <div className="hero-icons-ho">
              <div className="icon-card-ho">
                <span>🔍</span>
                <p>Search Pokémon</p>
              </div>
              <div className="icon-card-ho">
                <span>🎨</span>
                <p>Filter by type</p>
              </div>
              <div className="icon-card-ho">
                <span>📄</span>
                <p>Detailed profile</p>
              </div>
              <div className="icon-card-ho">
                <span>⚡</span>
                <p>Random Pokémon</p>
              </div>
            </div>
          </div>
          <div>
            <div>
              <ul className="ul-check">
                <li>
                  <span>✓</span> Updated information up to Gen 9
                </li>
                <li>
                  <span>✓</span> User-friendly and responsive interface{" "}
                </li>
                <li>
                  <span>✓</span> Dinamic view
                </li>
                <li>
                  {" "}
                  <span>✓</span> Frecuent asked questions section
                </li>
                <li>
                  <span>✓</span> Find a pokémon by name or type
                </li>
                <li>
                  <span>✓</span> Detailed profile displayed in cards
                </li>
              </ul>
            </div>
          </div>

          <div>
            <div className="dato-int">
              <span className="foco">💡</span>
              <div className="div-dato-flex">
                <p className="did-you-title">
                  {" "}
                  Did you know?... A fossil inspired the origin of Pokémon.
                </p>
                <p className="dato-satoshi">
                  Satoshi Tajiri , was inspired by his childhood of collecting
                  insects, which shaped the concept of capturing cretures.
                </p>
              </div>
            </div>
          </div>
          <div className="dato-int-acerca">
            <div className="acerca-proyecto">
              <h3>About the project</h3>
              <p>
                This project was created as a tool for Pokémon fans and curious
                developers. Check out data, explore Pokémon, and learn about
                them! All the content is educational.
              </p>
            </div>
          </div>
          {/* Aqui va todo lo del totorial */}
          <div className="tutorials">
            {ObjetoTutorial.map((objeto) => (
              <Tutorial key={objeto.description} objetoTutorial={objeto} />
            ))}
          </div>
          <div
            ref={ref}
            className={`contact-div slide-up ${isVisible ? "visibleY " : ""}`}
          >
            {" "}
            {/* Aquí va el efecto de up */}
            <div className="contact-question">
              <h3>Do you have any questions?</h3>
              <p>Hit me up! I'll be happy to hear from you.</p>
              <Link to="/contact">
                <BtnHome
                  onClick={() => setTitle("Contact — pandasneezing")}
                  fontSizeHo="21px"
                  colorBack="#3b82f6"
                  message={"Contact me!"}
                />
              </Link>
            </div>
            <div>
              <div className="social-links">
                <a
                  href="https://www.linkedin.com/in/bornsrss/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="linkedIn"
                >
                  <FaLinkedin className=" linkedin" />
                </a>
                <a
                  href="https://www.instagram.com/bornsrss/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                >
                  <FaInstagram className=" instagram" />
                </a>
                <a
                  href="https://mx.pinterest.com/bornsrss/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Pinterest"
                >
                  <FaPinterest className=" pinterest" />
                </a>
                <a
                  href="https://github.com/bornsrss14/_created/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Github"
                >
                  <FaGithub className=" github" />
                </a>
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <div onClick={scrollToTop} className="to-top-btn">
            <a href="#ds">
              <IconChevronCompactUp size={32} color="blue" />
            </a>
          </div>
          <footer className="footer-pke">
            <div className="footer-bottom-pke">
              <p>&copy; 2025 pandasneezing. Todos los derechos reservados.</p>
            </div>
          </footer>
        </div>
      </section>
    </>
  );
}

export default Home;
